import React from "react";
import CountryFlag from "../transfer-windows/CountryFlag";

// Country flag for a friendly card. The backend's coarse_country gives
// { name, code } where `code` is a lowercased alpha-2 → render the loaded
// flag-icons CSS class directly (same mechanism CountryFlag uses). When only a
// free-text country name is present (no Wyscout area → empty code) we defer to
// CountryFlag's name→code override table, else render nothing. Never crops.
const FriendlyFlag = ({ country, width = 18, height = 13, className = "" }) => {
  const code = (country?.code || "").trim().toLowerCase();
  const name = country?.name || "";
  if (code) {
    return (
      <span
        className={`fi fi-${code} inline-block bg-cover bg-center rounded-sm flex-shrink-0 ${className}`}
        style={{ width, height, boxShadow: "inset 0 0 0 0.5px rgba(0,0,0,0.08)" }}
        role="img"
        aria-label={name || code}
      />
    );
  }
  if (name) return <CountryFlag country={name} width={width} height={height} />;
  return null;
};

export default FriendlyFlag;
